import React from "react";
import AccountFormPage from "./AccountFormPage";

function AccountAddPage() {
  return <AccountFormPage mode="create" />;
}

export default AccountAddPage;
